import { render } from "./SettingsModalBox.vue?vue&type=template&id=6b81aa8c"
import script from "./SettingsModalBox.vue?vue&type=script&lang=js"
export * from "./SettingsModalBox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__